import { moneyFormater } from "../../../../utilities/formaters";

const TableCellNumber = ({ value }) => {
  let number = "";
  if (value) number = moneyFormater(Math.round(value * 100) / 100);
  return <div className="table-cell-money">{number}</div>;
};

export default TableCellNumber;
